import { api } from "~/api";
import { CustomImageType } from "~/Commons";

/**
 * 指定したkeyのカスタム画像を取得（オンプレ環境用）
 * @param key asset_key
 * @returns CustomImageType または null
 */
export const getOnpremCustomImageByKey = async (key: string): Promise<CustomImageType | null> => {
  try {
    const response = await api.dbWithParams.query({
      sql: `SELECT asset_key, url_path
      FROM custom_image
      WHERE asset_key = ?`,
      params: [key],
    });

    if (!response || !Array.isArray(response) || response.length === 0) {
      console.info(`キー ${key} のカスタム画像が見つかりませんでした`);
      return null;
    }

    const item = response[0] as { asset_key: string; url_path: string };

    return {
      key: item.asset_key,
      src: item.url_path,
    };
  } catch (error) {
    console.error("getOnpremCustomImageByKey でエラーが発生しました:", error);
    return null;
  }
};

/**
 * custom_image テーブルから全てのカスタム画像のURLを取得（オンプレ環境用）
 * @returns CustomImageType の配列
 */
export const getOnpremCustomImages = async (): Promise<CustomImageType[]> => {
  try {
    const response = await api.db.query(`
      SELECT asset_key, url_path
      FROM custom_image;
		`);

    if (!response || !Array.isArray(response)) return [];

    return (response as { asset_key: string; url_path: string }[]).map((item) => ({
      key: item.asset_key,
      src: item.url_path,
    }));
  } catch (error) {
    console.error("Error in getOnpremCustomImages:", error);
    return [];
  }
};
